import { application } from "./controllers/application"

function importAll(r) {
  r.keys().forEach(r)
}

importAll(require.context("../components", true, /[_\/]component\.[jt]s$/))
importAll(require.context("../components", true, /[_\/]component\.scss$/))
importAll(require.context("../components", true, /index\.scss$/))